export const APP_NAME = import.meta.env.VITE_APP_NAME || 'FuelFlow Pro'
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://127.0.0.1:8000/api/v1'
export const STORAGE_BASE_URL = import.meta.env.VITE_STORAGE_BASE_URL || 'http://127.0.0.1:8000/storage'
export const TOKEN_KEY = 'fuelflow_token'
export const USER_KEY = 'fuelflow_user'

export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 15,
  PAGE_SIZE_OPTIONS: [15, 30, 50, 100],
}

export const DATE_FORMATS = {
  SHORT: 'DD/MM/YYYY',
  LONG: 'DD MMM YYYY',
  WITH_TIME: 'DD/MM/YYYY HH:mm',
  ISO: 'YYYY-MM-DD',
}

export const FUEL_TYPE_LABELS: Record<string, string> = {
  diesel: 'Diesel',
  petrol: 'Petrol',
  lpg: 'LPG',
}

export const FUEL_TYPE_COLORS: Record<string, string> = {
  diesel: 'text-fuel-diesel bg-fuel-diesel/10',
  petrol: 'text-fuel-petrol bg-fuel-petrol/10',
  lpg: 'text-fuel-lpg bg-fuel-lpg/10',
}

export const ORDER_STATUS_COLORS: Record<string, string> = {
  draft: 'text-gray-600 bg-gray-100',
  pending_approval: 'text-yellow-600 bg-yellow-100',
  approved: 'text-blue-600 bg-blue-100',
  confirmed: 'text-indigo-600 bg-indigo-100',
  in_progress: 'text-purple-600 bg-purple-100',
  delivered: 'text-green-600 bg-green-100',
  cancelled: 'text-red-600 bg-red-100',
  completed: 'text-green-700 bg-green-200',
}

export const PAYMENT_STATUS_COLORS: Record<string, string> = {
  pending: 'text-yellow-600 bg-yellow-100',
  partial: 'text-orange-600 bg-orange-100',
  paid: 'text-green-600 bg-green-100',
  overdue: 'text-red-600 bg-red-100',
  cancelled: 'text-gray-600 bg-gray-100',
}
